import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=0a535742&scoped=true&"
import script from "./logistics.vue?vue&type=script&lang=js&"
export * from "./logistics.vue?vue&type=script&lang=js&"
import style0 from "./logistics.vue?vue&type=style&index=0&id=0a535742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a535742",
  null
  
)

export default component.exports